import type { Ref, TextareaHTMLAttributes } from "react";

import { cn } from "../lib/cn";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  ref?: Ref<HTMLTextAreaElement>;
}

/** Matches Input's border, radius and focus treatment. */
export function Textarea({ className, ref, ...props }: TextareaProps) {
  return (
    <textarea
      ref={ref}
      className={cn(
        "w-full rounded-lg p-lg",
        "bg-surface-container-lowest shadow-card",
        "text-field text-on-surface placeholder:text-on-surface-variant",
        "outline-none transition-colors",
        "focus:shadow-[inset_0_0_0_2.75px_var(--color-action)]",
        "disabled:opacity-45",
        className,
      )}
      {...props}
    />
  );
}
